import DocumentsView from './DocumentsView';
import withBasicClaimDocuments from './withBasicClaimDocuments';
import withExtendedClaimDocuments from './withExtendedClaimDocuments';

const BasicDocuments = withBasicClaimDocuments(DocumentsView);
export default BasicDocuments;
export const ExtendedDocuments = withExtendedClaimDocuments(DocumentsView);



// WEBPACK FOOTER //
// ./src/component/Documents/index.js